import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Meta } from "@/components/Meta";

export default function CommunityGuidelines() {
  return (
    <BasicScrollView center={false}>
      <Meta title={"Community guidelines"} />
      <MarkdownBlock markdown={TextBlocks.COMMUNITY_GUIDELINES_MARKDOWN} />
      <Footer />
    </BasicScrollView>
  );
}
